import Language from "../../components/language/Language"

function LanguagePage() {
    return (
        <>
            <Language />
        </>
    )
}
export default LanguagePage